export default __webpack_public_path__ + "assets/images/c33f760ea6cc052579a2ccda2d7d8947.png";